import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/esm/objectWithoutProperties';
import * as React from 'react';

var _excluded = ["title", "titleId"];
var X24 = function X24(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */React.createElement("svg", _objectSpread({
    fill: "none",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */React.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "M4.213 4.213a.727.727 0 0 1 1.029 0L12 10.972l6.759-6.759a.727.727 0 1 1 1.028 1.029L13.029 12l6.758 6.759a.727.727 0 0 1-1.028 1.028L12 13.029l-6.758 6.758a.727.727 0 0 1-1.029-1.028L10.972 12 4.213 5.242a.727.727 0 0 1 0-1.029"
  }));
};
X24.Size = 24;
X24.Title = "X";

export { X24 as X };
//# sourceMappingURL=X24-d4803ff3.js.map
